import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivateRoute from 'components/common/PrivateRoute';

import Header from 'components/Header';
import Footer from 'components/Footer';
import MainContainer from 'views/Home/MainContainer';
import ProductMainContainer from 'views/Main/MainContainer';
import PolicyModal from 'components/common/PolicyModal';
import PrivacyPolicy from 'views/Main/PrivacyPolicy';
import Terms from 'views/Main/Terms';
import MarketingTerms from 'views/Main/MarketingTerms';
import ThirdParty from 'views/Main/ThirdParty';
import Refund from 'views/Main/Refund';
import Mypage from 'views/Mypage';
import Product from 'views/Product';
import Login from 'views/Member/Login';
import ProductLogin from 'views/Product/Login';
import MobileFind from 'views/Member/Login/MobileFind';
import Join from 'views/Member/Join';
import Welcome from 'views/Member/Join/Welcome';
import Agreement from 'views/Member/SocialLogin/Agreement';
import DeleteAccount from 'views/Mypage/DeleteAccount';
import Payment from 'views/Product/payment';
import SuccessLoading from 'views/Product/payment/SuccessLoading';
import FailLoading from 'views/Product/payment/FailLoading';
import OrderComplete from 'views/Product/payment/OrderComplete';
import ProductMain from 'views/ProductMain';
import UserInfo from 'views/Mypage/UserInfo';
import ScrollToTop from 'components/common/ScrollToTop';
import Portfolio from 'views/Portfolio';
import PortfolioContactSuccess from 'views/Portfolio/ContactSuccess';
import Quotation from 'views/Quotation';
import QuotationResult from 'views/Quotation/Result';
import QuotationContactSuccess from 'views/Quotation/ContactSuccess';
import VideoLanding from 'views/Marketing/VideoLanding';

const RootRouter = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path='/' element={<VideoLanding />} />
        <Route path='/photo' element={<ProductMainContainer />} />        
        <Route path='/mass' element={<MainContainer />} />
        <Route path='/policyModal' element={<PolicyModal />} />        
        <Route path='/login' element={<Login />} />
        <Route path='/mobileFind' element={<MobileFind />} />
        <Route path='/join' element={<Join />} />
        <Route path='/welcomeSignup' element={<Welcome />} />
        <Route path='/agree' element={<Agreement />} />
        <Route path='/mypage' element={<PrivateRoute element={<Mypage />}/>} />
        <Route path='/userinfo' element={<PrivateRoute element={<UserInfo />}/>} />
        <Route path='/success' element={<SuccessLoading />} />
        <Route path='/complete' element={<OrderComplete />} />
        <Route path='/fail' element={<FailLoading />} />
        <Route path='/deleteAccount' element={<DeleteAccount />} />
        <Route path='/product' element={<ProductMain />} /> 
        <Route path='/product/:prodId' element={<Product />} />
        <Route path='/product/login' element={<ProductLogin />} />
        <Route path='/payment' element={<Payment />} /> 
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/portfolio/contact' element={<PortfolioContactSuccess />} />
        <Route path='/quotation' element={<Quotation />} />
        <Route path='/quotation/result' element={<QuotationResult />} />
        <Route path='/quotation/contact' element={<QuotationContactSuccess />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
        <Route path='/terms/1' element={<Terms />} /> 
        <Route path='/terms/2' element={<MarketingTerms />} />
        <Route path='/terms/3' element={<ThirdParty />} />        
        <Route path='/refund' element={<Refund />} />
      </Routes>
      <Footer />
    </Router>
  )
}

export default RootRouter;